/**
 * Nastaveí odkazy ve fromátu <a href="#..." data-animated-anchor>...</a> tak aby se
 * po kliknutní na ně provedla animace na odpovídající kotvu
 */

export function run()
{
    let offset = document.querySelector('nav').clientHeight * 1.5;
    document.querySelectorAll('a[data-animated-anchor]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            console.log('AnimatedAnchor: Clicked');
            e.preventDefault();
            let targetSelector = this.getAttribute('href');

            setTimeout(function () {
                let target = document.querySelector(targetSelector);

                if (target !== null) {
                    console.log(target, 'AnimatedAnchor: Target Found');
                    target.style.scrollMarginTop = offset + 'px';
                    target.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                }
            }, 50);
        });
    });
}

